import { ApiEndpoints } from '../api/apiEndpoints.constant';
import { BadRequestError } from '../domain/errors/BadRequestError';
import { BenefitPageApiError } from '../domain/errors/BenefitPageApiError';
import { BenefitTileApiError } from '../domain/errors/BenefitTileApiError';
import { GeneralApiError } from '../domain/errors/GeneralApiError';
import { NotFoundError } from '../domain/errors/NotFoundError';
import { NotLoggedInError } from '../domain/errors/NotLoggedInError';
import { BillCheckCreationFlowError } from '@/domain/errors/BillCheckCreationFlowError';

const responseStatusErrors = {
  400: { error: BadRequestError },
  401: { error: NotLoggedInError },
  404: { error: NotFoundError },
};

const endpointSpecificErrors = [
  { pattern: ApiEndpoints.memberships, error: BenefitPageApiError },
  { pattern: ApiEndpoints.userInteractions, error: BenefitPageApiError },
  { pattern: ApiEndpoints.schufaStatus, error: BenefitTileApiError },
  { pattern: ApiEndpoints.startBillCheck, error: BillCheckCreationFlowError },
  { pattern: ApiEndpoints.billCheckDetails, error: BillCheckCreationFlowError },
  { pattern: ApiEndpoints.generateSignedDocumentUploadUrl, error: BillCheckCreationFlowError },
  { pattern: ApiEndpoints.submitBillCheck, error: BillCheckCreationFlowError },
];

export const apiErrorMapper = async (requestUrl: string, response?: Response) => {
  if (response?.status && responseStatusErrors?.[response.status as keyof typeof responseStatusErrors]) {
    return new responseStatusErrors[response.status as keyof typeof responseStatusErrors].error();
  }

  const endpointError = endpointSpecificErrors.find(({ pattern }) => requestUrl.includes(pattern));
  if (endpointError) {
    return new endpointError.error();
  }

  if (response?.status) {
    const responseBody = await response?.json();
    return new GeneralApiError(response?.status, responseBody);
  }
  return new GeneralApiError();
};
